export class Comparison {
  static equals(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }
  static contains(array, x) {
    if (!array) {
      return false;
    }

    x = JSON.stringify(x);
    for (let i = 0; i < array.length; i++) {
      if (JSON.stringify(array[i]) === x) {
        return true;
      }
    }
    return false;
  }
  static indexOf(array, x) {
    x = JSON.stringify(x);
    return array.map(z => JSON.stringify(z)).indexOf(x);
  }
}

export class MyUtility {
  public static deepCopy(oldObj: any) {
    let newObj = oldObj;
    if (oldObj && typeof oldObj === 'object') {
      newObj = Object.prototype.toString.call(oldObj) === '[object Array]' ? [] : {};
      for (let i in oldObj) {
        newObj[i] = this.deepCopy(oldObj[i]);
      }
    }
    return newObj;
  }

  public static range(minInclusive, maxExclusive) {
    let retval = [];
    for (let i = minInclusive; i < maxExclusive; i++) {
      retval.push(i);
    }
    return retval;
  }

  public static prepareCriteriaForTransmitting(criteria) {
    let copy = this.deepCopyWithoutChildren(criteria);

    let propNames = Object.keys(copy.customCriteria);

    propNames.forEach(x => {
      let customSet = copy.customCriteria[x];
      if (customSet.selectedItems.length < 1) {
        delete copy.customCriteria[x];
      }
    });

    return copy;
  }

  public static deepCopyWithoutChildren(oldObj: any) {
    let newObj = oldObj;
    if (oldObj && typeof oldObj === 'object') {
      newObj = Object.prototype.toString.call(oldObj) === '[object Array]' ? [] : {};
      for (let i in oldObj) {
        if (i === 'children') {
          continue;
        }

        newObj[i] = this.deepCopyWithoutChildren(oldObj[i]);
      }
    }
    return newObj;
  }

  public static scrubChildren(arr) {
    if (!arr) {
      return;
    }

    for (let i = 0; i < arr.length; i++) {
      if (arr[i].children) {
        delete arr[i].children;
      }
    }
  }

  public static formatDate(date) {
    return date.toString().split('T')[0];
  }

  public static GetMousePointFromMouseEvent(event) {
    return { x: event.offsetX, y: event.offsetY };
  }

  public static isNothing(obj) {
    if (obj == null) {
      return true;
    }
    if (obj === "") {
      return true;
    }

    return false;
  }
}

export class MyRange {
  constructor(public min: number, public max: number) { }

  get span(): number {
    return this.max - this.min;
  }

  getInOrder() {
    if (this.min < this.max) {
      return;
    }

    let x = this.min;
    this.min = this.max;
    this.max = x;
  }

  compareValue(value: number) {
    if (value < this.min) {
      return -1;
    }
    if (value < this.max) {
      return 0;
    }
    return 1;
  }

  clampTo(min: number, max: number) {
    if (this.min < min) {
      this.min = min;
    }
    if (this.max > max) {
      this.max = max;
    }
  }
}
